import React from "react"

export const MegaphoneIconMedium = (props) => {
  return (
    <svg
      width={32}
      height={34}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m7.52 19.902 15.196 4.508V2L7.52 8.15v11.752Z"
        fill="#000"
      />
      <path
        d="M12.733 21.29V33H7.555V14.576"
        stroke="#035470"
        strokeWidth={1.8}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 19.902h5.52V8.426H2v11.476Zm5.52.065 15.195 4.525V2L7.52 8.173v11.794Z"
        fill="#FFD62E"
      />
      <path
        d="M2 19.902H.92v1.08H2v-1.08Zm5.52 0v1.08h1.079v-1.08h-1.08Zm0-11.476h1.079v-1.08h-1.08v1.08Zm-5.52 0v-1.08H.92v1.08H2Zm5.52 11.541h-1.08v.805l.771.23.308-1.035Zm15.195 4.525-.308 1.035 1.388.413v-1.448h-1.08Zm0-22.492h1.08V.396L22.309 1l.406 1ZM7.52 8.173l-.406-1-.673.274v.726h1.079ZM2 20.982h5.52v-2.16H2v2.16Zm6.599-1.08V8.426h-2.16v11.476H8.6ZM7.519 7.347H2v2.159h5.52v-2.16ZM.92 8.427v11.475h2.16V8.426H.92Zm6.291 12.575 15.196 4.525.616-2.07-15.196-4.524-.616 2.069Zm16.584 3.49V2h-2.16v22.492h2.16ZM22.309 1 7.113 7.173l.812 2L23.122 3l-.813-2ZM6.439 8.173v11.794H8.6V8.173h-2.16Z"
        fill="#FFD62E"
      />
      <path
        d="m26.6 18.613 4.5 3.08M26.6 7.835l4.5-3.08M27.049 13.081h4.95"
        stroke="#035470"
        strokeWidth={1.8}
      />
    </svg>
  )
}
